<template>
    <div class="search_form">
		<el-card :class="[!isCard ? 'hidden_card' : '']">
            <el-form :label-width="params.labelWidth || '135px'" class="yl_search_form yl_form" size="small">
                <el-row v-if="params && params.parmas">
                    <template v-for="(item,index) in params.parmas">
                        <el-col 
                            :span="params.parmas.length == 1 ? 10 : 8" 
                            :class="{hide:(index > 4 && searchToggle.state), 'inputw100': params.parmas.length < 3}" 
                            :key="index"
                            v-if="buildComponentIsShow(item)"
                        >
                            <el-form-item :label="item.title" align="left">
                                <span slot="label" v-if="item.tooltip" class="form_icon_tooltip">{{item.title.slice(0,7)}}
                                    <el-tooltip :content="item.tooltip" placement="top">
                                        <svg t="1639143822953" class="icon el_icon_tooltip" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5314" width="200" height="200">
                                            <path d="M512 960c-243.2 0-448-198.4-448-448 0-243.2 198.4-448 448-448 243.2 0 448 198.4 448 448s-204.8 448-448 448zM512 128C300.8 128 128 300.8 128 512s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z" p-id="5315"></path>
                                            <path d="M460.8 307.2c0 25.6 19.2 51.2 51.2 51.2s51.2-19.2 51.2-51.2S537.6 256 512 256s-51.2 19.2-51.2 51.2zM512 768c-19.2 0-32-12.8-32-32V448c0-19.2 12.8-32 32-32s32 12.8 32 32v288c0 19.2-12.8 32-32 32z" p-id="5316"></path>
                                        </svg>
                                    </el-tooltip>
                                </span>
                                <template v-if="!item.tooltip && item.title.length > 8">
                                    <span slot="label">
                                        <el-tooltip :content="item.title" placement="top">
                                            <span>{{item.title}}</span>
                                        </el-tooltip>
                                    </span>
                                </template>
                                <el-input 
                                    v-if="item.type=='text'" 
                                    v-model="params.request.options[item.prop]"
                                    :placeholder="item.placeholder" 
                                    v-bind="item.formAttr" 
                                    @change="item.changeCallback && item.changeCallback(params.request.options[item.prop])"
                                >
                                </el-input>
                                <!-- <el-autocomplete
                                    v-if="item.type=='autocomplete'" 
                                    class="w100"
                                    v-model="params.request.options[item.prop]"
                                    :placeholder="item.placeholder"
                                    :fetch-suggestions="querySearchAsync"
                                    @focus="getAsyncAPI(item)"
                                    @select="handleSelect"
                                >
                                </el-autocomplete> -->
                                <el-select v-if="item.type=='select'" 
                                    v-model="params.request.options[item.prop]"
                                    :placeholder="item.placeholder" 
                                    :class="{'select_maxwidth': params.parmas.length > 2}"
                                    v-bind="item.formAttr" 
                                    @change="item.changeCallback && item.changeCallback(params.request.options[item.prop])" 
                                    @focus="getAsyncAPI(item)"
                                    :remote-method="(query) => remoteMethod(query, item)"
                                >
                                    <el-option 
                                        v-for="childItem in item.data" 
                                        :key="childItem[item.key]" 
                                        :label="childItem['name'] || childItem[item['label']]" 
                                        :value="childItem['code']"
                                    >
                                    </el-option>
                                </el-select>
                                <el-date-picker v-if="item.type=='month'" v-model="params.request.options[item.prop]" type="month" :placeholder="item.placeholder" :value-format="item.valueFormat || 'timestamp'" :picker-options="item.pickerOptions"></el-date-picker>
                                <el-date-picker v-if="item.type=='date'" v-model="params.request.options[item.prop]" type="date" :placeholder="item.placeholder" :value-format="item.valueFormat || 'timestamp'" :picker-options="item.pickerOptions"></el-date-picker>
                                <el-date-picker 
                                    v-if="item.type=='daterange'" 
                                    unlink-panels 
                                    v-model="params.request.options[item.prop]" 
                                    type="daterange" 
                                    :default-time="['00:00:00','23:59:59']" 
                                    :value-format="item.valueFormat || 'timestamp'" 
                                    range-separator="至" 
                                    start-placeholder="开始日期" 
                                    end-placeholder="结束日期" 
                                    :picker-options="item.pickerOptions"
                                    @change="updateDaterangeProp(item)"
                                >
                                </el-date-picker>
                                <el-cascader
                                    v-if="item.type=='cascader'"
                                    v-model="params.request.options[item.prop]"
                                    v-bind="item.formAttr"
                                    :options="item.data"
                                    :props="{
                                        label:item.label || 'label',
                                        value:item.code || 'value',
                                        disabled:item.disabled || true,
                                        children:item.children || 'children'
                                    }"
                                    @change="item.changeCallback && item.changeCallback(params.request.options[item.prop])" 
                                ></el-cascader>
                            </el-form-item>
                        </el-col>
                    </template>
                    <el-col :span="8" :class="['search_box', {'fr': params.parmas.length != 1}, (params.parmas.length > 2) ? 'text-right' : 'text-left']">
                        <el-form-item :label-width="params.parmas.length < 3 ? '16px' : ''">
                            <div class="select_maxwidth">
                                <el-button @click='searchStateToggle' type="text" v-if="params.parmas.length > 5">{{searchToggle.text}}<i :class="searchToggle.icon"></i></el-button>
                                <el-button @click="reset" :disabled="searchIsDisabled" v-if="params.parmas.length > 2">重置</el-button>
                                <el-button type="primary" :disabled="searchIsDisabled" @click="search">查询</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
		</el-card>
    </div>
</template>

<script>
import lowcode from '../../../lib/main.js';
import mixin from "./mixin"
export default {
    name:"yl-lc-search",
    mixins:[mixin],
	data(){
        return {
            searchToggle:{
                state:true,
                text:"展开",
                icon:"el-icon-arrow-down"
            },
            PageSize: 20,
            searchCopyParmas: null,
            params:[],
            data:null,
            options:null,
            fetchApi:{},
            uri:""
        }
    },
    props: {
        searchParmas:{
            type:[Object,Array],
            default:null
        },
        load:{
            type:Boolean,
            default:true
        },
        isCard:{
            type:[Boolean],
            default: true
        },
        searchIsDisabled:{
            type:[Boolean],
            default: false
        },
        // 表格组件ref
        tableRefs:{
            type:Object,
            default:null
        },
        // 表格组件ref名称
        tableRefsName:{
            type:String,
            default:null
        },
        beforeSearch: Function,
    },
    watch: {
        "searchParmas":{
            handler(newVal,oldVal){
                this.params = newVal;
                this.options = newVal.request.options;
            },
            immediate:true
        }
    },
	components: {},
	mounted(){
        this.params.parmas.forEach(item=>{
            if(item.__on__ && item.__on__.length>0){
                item.changeCallback = lowcode.executeEvent(item.__on__[0]);
            }
            if(item.dataSource.body){
                let sourceData = this.resolveSource(item.dataSource.body);
                if(sourceData.run){
                    sourceData.run('',item).then(res=>{
                        item.data = res.data.data;
                    })
                }else{
                    item.data = sourceData;
                }
            }
        })
        this.searchCopyParmas = JSON.parse(JSON.stringify(this.params));
        let _this = this;
        this.$nextTick(function(){
            if(_this.load && !_this.searchIsDisabled){
                _this.search()
            }
            //数据回显
            _this.updateParmas();
        })
	},
	methods: {
        resolveApi(){
            let data = this.params.request.source;
            if(data){
                let API = this.resolveSource(data);
                API = this.$function.BASE.repeatObject(API);
                this.uri = window.LOWCODE['power'] && window.LOWCODE['power'].includes(window.location.hostname) ? API.proxy + this.params.request.url : this.params.request.url;
                if(API){
                    Object.keys(API.params).map(key=>{
                        API.params[key] = this.resolveSource(API.params[key]);
                    });
                }
                return API
            }
        },
        search(pageData){
            let asyncParmas = this.resolveApi();
            //有分页参数时拼接分页字段
            if(pageData && pageData.page){
                pageData = {
                    page:pageData && pageData.page ? pageData.page : 1,
                    pageRow:pageData && pageData.pageRow ? pageData.pageRow : 20
                }
            }
            let options = asyncParmas ? Object.assign({},asyncParmas.params,pageData): {};
            if(this.params.routerPush){
                this.$APP.$router.push({
                    path:this.$APP.$route.path,
                    query:Object.assign({},this.$APP.$route.query,this.params.request.options)
                });
            }
            this.getList(options,asyncParmas)
        },
        // 重置事件
        reset(){
            for (let data in this.params.request.options) {
                this.$set(this.params.request.options, data, this.searchCopyParmas.request.options[data])
            }
            // 是否启用路由
            if(this.params.routerPush){
                this.$APP.$router.push({
                    path:this.$APP.$route.path,
                    query:Object.assign({},{
                        localRandom:Math.random()
                    },this.params.request.options)
                });
            }
            this.$emit("reset", this.params.request.options)
            this.search();
        },
        getList(pageData,API){
            if(this.params.request && this.uri){
                let repeatOptions=this.$function.BASE.repeatObject(pageData);
                Object.keys(repeatOptions).forEach(function(key){
                    if(key.indexOf("|")!=-1){
                        let keyArray=key.split("|");
                        keyArray.map((item,index)=>{
                            repeatOptions[item]=repeatOptions[key]?repeatOptions[key][index]:"";
                        });
                        delete repeatOptions[key];
                    }
                });
                //参数为空时，可能会拼接到该字段
                if(repeatOptions.hasOwnProperty("isTrusted")){
                    delete repeatOptions.isTrusted;
                }
                let proxy = JSON.parse(sessionStorage.getItem("proxy")) || {};
                let env = window.location.pathname.split('/')[1] == 'lc' ? true : false;
                if(window.LOWCODE['power'].includes(window.location.hostname) && (!env || proxy['isProxy'])){
                    //开发环境
                    let branchId = window.location.pathname.split('/').slice(-1).join();
                    let repositoryId = lowcode.getRepId(API.proxy, true);
                    window.LOWCODE['axios'].POST({
                        method:'POST',
                        url:"/zqyl-lowcode-api/rap/mock",
                        data:{
                            targetType:lowcode.getAxiosBase(API).indexOf('rap.corp.yljr.com') != -1 ? 1 : 2,
                            method:API.method,
                            url:this.uri,
                            headerMap:{
                                'Content-Type': API.contentType || lowcode.contentType.get
                            },
                            paramMap: repeatOptions,
                            token:proxy[branchId] ? proxy[branchId] :'',
                            repositoryId
                        }
                    }).then(res=>{
                        this.data = res.data;
                        this.$emit("success",{
                            data:res.data || {},
                            page:(pageData && pageData.page) ? pageData : { page: 1 } 
                        });
                    });
                }else{
                    //生产环境
                    window.LOWCODE['axios'].GET(this.uri,{params: repeatOptions}).then(res=>{
                        this.data = res.data;
                        this.$emit("success",{
                            data:res.data || {},
                            page:(pageData && pageData.page) ? pageData : { page: 1 } 
                        });
                    }).catch(error=>{
                        console.error(error);
                    });
                }
            }else{
                this.$message.warning('请绑定查询接口')
            }
        },
        updateParmas(){
            let searchParams=this.params.parmas || {};
            let routeParams=this.$APP.$route.query;
            let optionParams = this.params.request.options || {};
            //同步地址信息到接口
            searchParams.length > 0 && searchParams.forEach(item=>{
                if(routeParams[item.prop] != null && routeParams[item.prop]!=undefined){
                    let val = typeof optionParams[item.prop]=="number"?(routeParams[item.prop]!=""?Number(routeParams[item.prop]):routeParams[item.prop]):routeParams[item.prop];
                    this.$set(optionParams, item.prop , val);
                }
            })
        },
        //查询收起展开
        searchStateToggle(){
            if(!this.searchToggle.state){
                this.searchToggle={
                    state:true,
                    text:"展开",
                    icon:"el-icon-arrow-down"
                };
                this.offsetSearchSpan=24-this.searchButtonSpan;
            }else{
                this.searchToggle={
                    state:false,
                    text:"收起",
                    icon:"el-icon-arrow-up"
                };
                this.offsetSearchSpan=0;
            }
        },
        buildComponentIsShow(row){
            return !row.isShow.isAction ? lowcode.execute(row.isShow.body) : row.isShow.status;
        },
        getAsyncAPI(source){
            let data = source.dataSource.body;
            if(data){
                this.fetchApi.API = this.resolveSource(data);
            }
        },
        handleSelect(data){
            this.$emit("select",data);
        },
        remoteMethod(query,item){
            if(this.fetchApi.API){
                let API = this.fetchApi.API;
                if(API){
                    Object.keys(API.params).map(key=>{
                        API.params[key] = this.resolveSource(API.params[key])
                    });
                    API.run(query,item).then(res=>{
                        item.data = res.data.data;
                    })
                }
            }
        },
        updateDaterangeProp(data){
            let vals = this.params.request.options[data.prop]
            this.params.request.options[data.propStart] = vals[0];
            this.params.request.options[data.propEnd] = vals[1];
        },
        setOption(index,field,data){
            this.$set(this.params.parmas[index],field,data);
        }
	}
}
</script>
<style>
.prism_editor .hoverText{ font-size: 13px;}
.prism_editor .hoverText:hover{color: #409EFF;}
.prism-editor__textarea:focus {
    outline: none;
}
.my-editor {
    background-color: #fafafa;
    max-height: 400px;
    font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
    font-size: 14px;
    line-height: 1.5;
    padding: 5px 10px;
    margin-bottom: 10px;
}
.el-cascader{
    width: 100%;
    max-width: 480px;
}
</style>